import React, { useState } from 'react';
import illustration from '../../../../../images/survey/survey-1-illustration.svg';
import ButtonComponent from '../../../../common-components/ButtonComponent/ButtonComponent';
import RightArrow from '../../../../Icons/icons/RightArrow';
import { useSurveyContext } from './surveyContext';
import LeftArrow from '../../../../Icons/icons/LeftArrow';
import { surveyForm3Validation } from '../../../../../utils/validationSchema';
import { updateStorageObject } from '../../../../../utils/global';
import { addSurveyData } from '../../../../../services/survey.service';
import { NotificationManager } from 'react-notifications';
import { useFormValidation } from '../../../../../hooks/useFormValidation';
import { Mixpanel } from '../../../../../utils/mixpanel';

const RevenueOptions = [
  { label: 'Just getting started', value: '$0' },
  { label: '$300K - $1M', value: '$300K - $1M' },
  { label: '$1M - $3M', value: '$1M - $3M' },
  { label: '$3M - $10M', value: '$3M - $10M' },
  { label: '$10M+', value: '$10M+' },
];

const ObjectiveOptions = [
  { label: 'Seeding / Gifting', value: 'Seeding / Gifting' },
  { label: 'Paid Promotions', value: 'Paid Promotions' },
  { label: 'I need UGC', value: 'I need UGC' },
  { label: 'Ambassador Program', value: 'Ambassador Program' },
  { label: 'Still figuring out', value: 'Still figuring out' },
];

const TeamSize = [
  { label: '1-10', value: '1-10' },
  { label: '10-25', value: '10-25' },
  { label: '25-50', value: '25-50' },
  { label: '50-100', value: '50-100' },
  { label: '100+', value: '100+' },
];

const SurveyPage3 = () => {
  const { setSurveyFormStep, form1Data, form2Data, form3Data, setForm3Data } = useSurveyContext();

  const [isLoading, setIsLoading] = useState(false);

  const { errors, setErrors, validate } = useFormValidation(surveyForm3Validation);

  const onFormSubmit = async (e) => {
    e?.preventDefault();
    const isValid = validate(form3Data);
    if (!isValid) return;
    updateStorageObject('onboarding-form-data', 'form3', form3Data);
    setIsLoading(true);

    const response = await addSurveyData({ ...form1Data, ...form2Data, ...form3Data });
    Mixpanel.track('onboarding_step_completed', { "Step Name": "Third Step", "Step Number": 3, Responses: form3Data });
    if (response?.status) {
      setSurveyFormStep(4);
    } else {
      NotificationManager.error('Something Went Wrong', '', 1500);
    }
    setIsLoading(false);
  };
  return (
    <form onSubmit={onFormSubmit}>
      <div className="survey-3-container">
        <div className="survey-3-content">
          <div className="survey-3-form">
            <div className="survey-3-question">
              <CustomButtonSelectInput
                title="Where are you on the revenue spectrum?"
                subTitle="This helps us recommend the right strategy for you, based on stage"
                options={RevenueOptions}
                value={form3Data.revenue}
                onSelect={(o) => {
                  setErrors((e) => ({ ...e, revenue: null }));
                  setForm3Data((p) => ({ ...p, revenue: o }));
                }}
                error={errors.revenue}
                disabled={isLoading}
              />
              <CustomButtonSelectInput
                title="What is your primary objective with SARAL and influencer marketing?"
                options={ObjectiveOptions}
                value={form3Data.objective}
                onSelect={(o) => {
                  setErrors((e) => ({ ...e, objective: null }));
                  setForm3Data((p) => ({ ...p, objective: o }));
                }}
                error={errors.objective}
                disabled={isLoading}
              />
              <CustomButtonSelectInput
                title="How big is your team?"
                options={TeamSize}
                value={form3Data.teamSize}
                onSelect={(o) => {
                  setErrors((e) => ({ ...e, teamSize: null }));
                  setForm3Data((p) => ({ ...p, teamSize: o }));
                }}
                error={errors.teamSize}
                disabled={isLoading}
              />
            </div>
            <div className="survey-3-bottom-container">
              <ButtonComponent
                disabled={isLoading}
                onClick={() => setSurveyFormStep(2)}
                style={{ flex: 1 }}
                variant="secondary">
                <LeftArrow color="var(--icon-subdued)" width={24} height={24} />
                Back
              </ButtonComponent>
              <ButtonComponent type="submit" style={{ flex: 1 }} showLoading={isLoading}>
                Let’s Begin! <RightArrow color="#fff" />
              </ButtonComponent>
            </div>
          </div>
          <div className="survey-3-illustration">
            <img src={illustration} alt="illustration" />
          </div>
        </div>
      </div>
    </form>
  );
};

const CustomButtonSelectInput = ({ title, subTitle, options, onSelect, disabled, value, error }) => {
  return (
    <div className="custom-button-select-input-container">
      <div className="custom-button-select-input-title-container">
        <div className="custom-button-select-input-title">{title}</div>
        {subTitle && <div className="custom-button-select-input-sub-title">{subTitle}</div>}
      </div>
      <div className="custom-button-select-input-option-container">
        {options.map((option) => (
          <div
            className={`option-button ${option.value === value ? 'option-button-active' : ''}`}
            key={option.value}
            onClick={() => {
              if (disabled) return;
              onSelect(option.value);
            }}>
            {option.label}
          </div>
        ))}
      </div>
      {error && <div className="survey-error-text">{error}</div>}
    </div>
  );
};

export default SurveyPage3;
